<template>
<div id="check">
    <link href="https://fonts.googleapis.com/css?family=Open+Sans:300,400,600,700,800&display=swap" rel="stylesheet">
    <service-index :user.sync="user" :city.sync="city" :auth.sync="auth" :service.sync="service" :leads.sync="leads" v-if="auth.role === 1"/>
    <user-index  :user.sync="user" :city.sync="city" :auth.sync="auth" :leads.sync="leads" v-if="auth.role === 0"/>
</div>
</template>

<script>
import ServiceIndex from '@/components/cabinet/service/index'
import UserIndex from '@/components/cabinet/user/index'
export default {
  name: 'check.vue',
  props: ['city', 'user', 'auth', 'service', 'leads'],
  components: {
    ServiceIndex,
    UserIndex
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cabinet/check.vue